var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cAgreeChoice-container",on:{"click":_vm.agrees}},[_c('li',{staticClass:"select-item",class:_vm.agree ? 'select-active' : ''},[_c('img',{attrs:{"src":_vm.imgurl}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.text))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d18a6f7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button/cArgeeButton.vue
// module id = null
// module chunks = 